import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, LanguageKeyType, LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-language-container-config',
  templateUrl: './language-container-config.component.html',
  styleUrls: ['./language-container-config.component.scss']
})
export class LanguageContainerConfigComponent implements OnInit {
  parentId = ''; languageKeyType: LanguageKeyType = LanguageKeyType.None; languageContents: KeyValues3[] | any; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.parentId) {
      this.languageManagementService.getLanguageContainer(this.parentId, this.languageKeyType).subscribe(result => {
        this.languageContents = result;
      });
    } else {
      this.languageContents = [];
    }
  }

  onEmptyLanguageContainerAdded(e) {
    this.languageContents = e;
  }

  onPopupSave() {
    this.activeModal.close({ event: TriggeredEvent.Ok, data: this.languageContents });
  }

}
